import { useTranslation } from "react-i18next";
import { useLanguage } from "../../contexts/LanguageContext";
import { Upload, Cpu, FileOutput } from "lucide-react";

const steps = [
  { key: "step1", icon: Upload },
  { key: "step2", icon: Cpu },
  { key: "step3", icon: FileOutput },
];

export default function UseCasesSection() {
  const { t } = useTranslation();
  const { dir } = useLanguage();

  return (
    <section
      className="py-24 md:py-32 border-y border-[var(--landing-border)]"
      style={{ backgroundColor: "var(--landing-surface-alt)" }}
      dir={dir}
    >
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: "var(--landing-text)" }}
          >
            {t("usecases.title")}
          </h2>
          <p
            className="text-lg leading-relaxed"
            style={{ color: "var(--landing-text-secondary)" }}
          >
            {t("usecases.subtitle")}
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-12 md:gap-8">
          {steps.map(({ key, icon: Icon }, i) => (
            <div
              key={key}
              className="relative flex flex-col items-center text-center"
            >
              <div
                className="relative flex items-center justify-center w-16 h-16 rounded-2xl border border-[var(--landing-border)] mb-4"
                style={{
                  backgroundColor: "var(--landing-surface)",
                  boxShadow: "var(--landing-shadow)",
                }}
              >
                <Icon className="h-8 w-8" style={{ color: "var(--landing-primary)" }} />
                <span
                  className="absolute -top-1 -right-1 w-6 h-6 rounded-full text-xs font-bold flex items-center justify-center text-white"
                  style={{ backgroundColor: "var(--landing-primary)" }}
                >
                  {i + 1}
                </span>
              </div>
              <h3
                className="font-semibold text-lg mb-2"
                style={{ color: "var(--landing-text)" }}
              >
                {t(`usecases.${key}`)}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
